import { render } from "./SingleSignOn.vue?vue&type=template&id=55b54c36&scoped=true"
import script from "./SingleSignOn.vue?vue&type=script&lang=js"
export * from "./SingleSignOn.vue?vue&type=script&lang=js"

import "./SingleSignOn.vue?vue&type=style&index=0&id=55b54c36&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b54c36"]])

export default __exports__